import React from "react";
import { Icon } from "../../components";
import metadata from "./block.json";
import "../assets/sass/blocks/post-title/style.scss";
import Edit from "./Edit";

export const name = metadata.name;

export const settings = {
	...metadata,
	icon: <Icon type="blockIcon" name="postTitle" size={24} />,
	edit: Edit,
	save: () => null,
};
